import type {SendAnalyticsEventFunction} from '@github-ui/use-analytics'

import {createQueryPersister} from './create-query-persister'
import type {Validator} from 'typebox/compile'
import {createSafeIndexedDbPersister} from './create-safe-indexed-db-storage'
import type {Persister} from './types'

type Props = {
  validator: Validator
  sendAnalyticsEvent: SendAnalyticsEventFunction
  prefix?: string
  maxAgeMs?: number
  alwaysRefetch?: boolean
  enabled?: boolean
}

const THREE_DAYS = 1000 * 60 * 60 * 24 * 3

export const noOpPersister: Persister = async (queryFn, context) => await queryFn(context)

export const createPersister = ({
  validator,
  sendAnalyticsEvent,
  prefix = 'key',
  maxAgeMs = THREE_DAYS,
  alwaysRefetch,
  enabled = true,
}: Props) => {
  if (!enabled) return noOpPersister

  const persist = createQueryPersister({
    storage: createSafeIndexedDbPersister({validator, sendAnalyticsEvent}),
    prefix,
    maxAgeMs,
    // always refetch when loading, or refetch with data is stale
    refetchOnRestore: alwaysRefetch ? 'always' : true,
  })

  return persist.persisterFn
}
